// extracted by mini-css-extract-plugin
export default {"wrapper":"Avatar_wrapper__QJYFD","initials":"Avatar_initials__hNPSF"};